import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { fetchWithJwtClaimsRetry } from '@/lib/jwtClaimsRetry';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    // Pas d'option `storage` : supabase-js garde la session dans le localStorage
    // du navigateur (en mémoire hors navigateur). Le relais de Lovable, qui la
    // transmettait à l'éditeur lovable.dev dans ses aperçus, a été retiré.
    persistSession: true,
    autoRefreshToken: true,
  },
  // Ajout manuel, à conserver si ce fichier est régénéré (garde-fou :
  // client.test.ts). Renvoie une fois les requêtes refusées en PGRST303 dans
  // la seconde qui suit un renouvellement de jeton — voir `jwtClaimsRetry`.
  global: {
    fetch: fetchWithJwtClaimsRetry,
  },
});
